import React, { Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import FederatieOverzichtForm from "./FederatieOverzichtForm";
import AutoBindComponent from "../../common/AutoBindComponent";
import FederatieOverzichtPageHelper from "./FederatieOverzichtPageHelper";
import PropTypes from 'prop-types';
import * as layoutActions from "../../../actions/e-loketLayoutActions";
import redirector from "../../../util/redirector";
import { throwException } from "../../../actions/exceptionActions";
import * as securityActions from "../../../actions/securityActions";
import SelectInput from "../../common/SelectInput";
import * as DomainConstants from "../../../constants/DomainConstants";

class FederatieOverzichtPage extends AutoBindComponent {
    constructor(props, context) {
        super(props, context, true);

        this.state = {
            model: null,
            provincieFilter: {
                provincieIdFuture: ""
            },
            statusFilter: {
                statusFuture: DomainConstants.TochtRedenVanStatus.InAfwachtigingVanGoedkeuringDoorFedKoepel
            },
            gemeenteFilter: {
                gemeentePast: ""
            },
            hoofdgemeenten: []
        };

        this.pageHelper = new FederatieOverzichtPageHelper(this, redirector);
    }

    componentDidMount = () => {
        super.componentDidMount();
        this.pageHelper.init();
    };

    handleOnChangeProvincie(event) {
        this.pageHelper.onChangeProvincie(event.target.value, event.target.name);
    }

    handleOnChangeStatus(event) {
        this.pageHelper.onChangeStatus(event.target.value, event.target.name);
    }

    handleOnChangeGemeente(event) {
        this.pageHelper.onChangeGemeente(event.target.value, event.target.name);
    }

    handleOnKeurKalenderGoed(provincieIdKey) {
        this.pageHelper.onKeurKalenderGoed(provincieIdKey);
    }

    isReadyToRender = () => {
        return this.state.model && this.props.provincies;
    };

    handleOnChangeOrganisation = (event) => this.pageHelper.onChangeOrganisation(event);

    render() {
        if (!this.isReadyToRender())
            return null;

        const model = this.state.model;
        const provincies = this.props.provincies;

        const props = this.props;
        const headerStyle = { 'color': '#006fB7', 'fontSize': '32px', 'display': 'flex', 'alignItems': 'center', 'justifyContent': 'center', 'fontWeight': '500', 'padding': '0px', 'margin': '0px', 'backgroundColor': 'white', 'minHeight': '91.2px' };

        return (
            <Fragment>
                {props.organisations.length === 1 ?
                    <div style={headerStyle}>{`${props.organisations[0].label}`}</div>
                    :
                    <div style={headerStyle}>
                        <div style={{ 'width': '30%', 'margin-left': '0.75rem' }}>
                            <SelectInput defaultItem="Kies je federatie ......"
                                name="organisation"
                                value={props.currentOrganisation}
                                items={props.organisations}
                                onChange={this.handleOnChangeOrganisation} />
                        </div>
                    </div>
                }

                <FederatieOverzichtForm
                    model={model}
                    provincies={provincies}
                    onChangeProvincie={this.handleOnChangeProvincie}
                    provincieFilter={this.state.provincieFilter}
                    onChangeStatus={this.handleOnChangeStatus}
                    statusFilter={this.state.statusFilter}
                    hoofdgemeenten={this.state.hoofdgemeenten}
                    gemeenteFilter={this.state.gemeenteFilter}
                    onChangeGemeente={this.handleOnChangeGemeente}
                    onKeurKalenderGoed={this.handleOnKeurKalenderGoed}
                />
            </Fragment>
        );
    }
}

FederatieOverzichtPage.propTypes = {
    provincies: PropTypes.array.isRequired
};

function mapStateToProps(state, ownProps) {
    return {
        provincies: state.referentie.provinciesInVlaamsGewest,
        currentOrganisation: state.security.currentOrganisation.replaceAll('.', ''),
        organisations: state.security.organisations.map(x => { return { label: x.naam, value: x.organisatienummer.replaceAll('.', '') }; }),
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        loadFederatieOverzichtLayout: bindActionCreators(layoutActions.loadFederatieOverzichtLayout, dispatch),
        throwException: bindActionCreators(throwException, dispatch),
        loadAuthorizationInfo: bindActionCreators(securityActions.loadAuthorizationInfo, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(FederatieOverzichtPage);